var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('Om')],1),_c('div',{staticClass:"column is-one-third has-text-centere has-text-centered"},[_c('Img',{attrs:{"src":"cykel","alt":"Din personliga redovisningsbyrå","text":[
          'Kristina Nilsson, redovisningskonsult,',
          'på ”tjänstecykeln”'
        ]}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }